import React, {useEffect} from 'react'
import { withAuthenticationRequired } from "@auth0/auth0-react";

//Redux
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    usuarioActivo: state
})
let HomeDesign = (props) => {
    useEffect(() => {
        document.title = "Home";
    })
    return (
        <React.Fragment>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <div
                    className={"page-title-heading"}>
                    Bienvenido {props.usuarioActivo.userData !== undefined ? props.usuarioActivo.userData.nombre ? props.usuarioActivo.userData.nombre.split(' ')[0] : '' : ''}
                </div><br></br>
                <div
                    className={"page-title-subheading"}>
                    Sysconfi - Confipetrol &#169; {new Date().getFullYear()}
                </div>
            </div>
        </React.Fragment>
    )
}

export default connect(mapStateToProps)(HomeDesign);